import React, { ReactNode } from "react";
import { setDropzoneRef } from "@lib/dropzoneRef";
import {
    AvatarUploadContextValue,
    useAvatarUpload,
} from "../../../contexts/avatarUpload.context";

interface Props {
    children:
        | ReactNode
        | ((open: AvatarUploadContextValue["open"]) => ReactNode);
}

export const AvatarUpload: React.FC<Props> = ({ children }) => {
    const { open, inputProps } = useAvatarUpload();

    return (
        <>
            {typeof children === "function" ? children(open) : children}
            <input
                {...inputProps}
                className="d-none"
                data-testid="avatar-upload-input"
                ref={(el) => setDropzoneRef(inputProps, el)}
            />
        </>
    );
};
